import { Currency } from '../server-types';
import { VenueType } from '../generated/graphql';

export type FormSubmitType<T> = (values: T) => Promise<void>;

export interface Padded {
    padding?: number;
}

export type MakeRequired<T> = {
    [P in keyof T]-?: NonNullable<T[P]>;
};

export interface FullHeight {
    fullHeight?: boolean;
}

export * from './timelineEvent';
export * from './routeTypes';

export interface Named {
    name: string;
}

export interface Identified {
    id: string;
}
export interface PaginationArgs {
    offset: number;
    limit?: number;
}

export interface Token {
    role: string;
    employeeId: string;
    enterpriseId: string;
    currentVenueId: string;
    defaultTimezone: string;
    cultureCode: string;
    languageCode: string;
    defaultCurrency: Currency;
    venueIds: string[];
    iat: number;
    exp: number;
    venueType: VenueType;
}
